import { ReduxRootState } from "../types/redux-store";
import { getGenericEntities } from "./selectorUtils";
export const COLLAB_ENTITY = "externalCollab" as const;
export const COLLAB_CHAT_ENTITY = "collaboration" as const;

export const getThemes = (state: ReduxRootState) =>
  getGenericEntities(state, state.entities[COLLAB_ENTITY].themes);
export const getThemesById = (state: ReduxRootState) =>
  state.entities[COLLAB_ENTITY].themes.byId;
export const getLinks = (state: ReduxRootState) =>
  getGenericEntities(state, state.entities[COLLAB_ENTITY].links);

export const getCollaborators = (state: ReduxRootState) =>
  state.entities[COLLAB_CHAT_ENTITY].collaborators;

export const unreadCommentsSelector = (state: ReduxRootState) =>
  state.entities[COLLAB_CHAT_ENTITY].unreads;
